import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Lightbox } from '../shared/Lightbox';
import { Reveal } from '../shared/Reveal';
import { SectionHeading } from '../shared/SectionHeading';
import { WorkTile } from '../shared/WorkTile';
import { useLanguage } from '../../contexts/LanguageContext';
import { useProjects } from '../../hooks/useProjects';
export function RecentWork() {
  const {
    t
  } = useLanguage();
  const all = useProjects();
  const shown = all.slice(0, 6);
  const viewable = useMemo(() => shown.filter(p => p.image), [shown]);
  const [index, setIndex] = useState<number | null>(null);
  return <section aria-labelledby="work-title" className="bg-cream py-20 sm:py-24" data-id="element-53" data-mp="31cviqvfmtd97">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-54" data-mp="31ey617pegsa8">
        <Reveal data-id="element-55" data-mp="3fdelbn1bvr3z">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-56" data-mp="3fcwgi20lo4kg">
            <SectionHeading id="work-title" title={t.home.work.title} description={t.home.work.description} data-id="element-57" data-mp="3bbt27jy7aglc" />
            <Link to="/portfolio" className="group inline-flex items-center gap-2 text-sm font-medium text-mauve" data-id="element-58" data-mp="24bp1apwq3dou">
              {t.home.work.viewAll}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-59" data-mp="2db25b322va26" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 lg:grid-cols-3" data-id="element-60" data-mp="2i827h2vt3so0">
          {shown.map((project, i) => <Reveal key={project.id} delay={0.04 * (i % 3)} className="h-full" data-id="element-61" data-mp="2ral6td0dvn5i" data-mpi={i}>
              <WorkTile project={project} viewLabel={t.home.work.viewProject} onOpen={() => setIndex(viewable.findIndex(v => v.id === project.id))} data-id="element-62" data-mp="2w1js6r08bbfm" />
            </Reveal>)}
        </div>
      </div>
      <Lightbox items={viewable} index={index} onClose={() => setIndex(null)} onChange={setIndex} data-id="element-63" data-mp="361kf0mxb49ok" />
    </section>;
}